import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import URLs from '../../../../../utils/appURLs';
import { updateToast } from '../../../../../common/redux/reducer/commonSlices/toastSlice';
import axiosInstance from '../../../../../app/config/axiosInstance';

const serviceContext = process.env.REACT_APP_SERVICE_CONTEXT;

type ReturnedType = any;

export interface Loads {
  customerLocation: any;
  stakeholderPairModels: any;
  id: number;
  truckLoadType: string;
  loadType: string;
  loadName: string;
  customerId: string;
  weight: number;
  description: string;
  length: number;
  customerAddress: string;
  customerLatitude: string;
  customerLongitude: string;
  width: number;
  height: number;
  totalCost: string;
  isActive?: number;
  freightNumbers: string;
  loadNumber: string;
  pickupInstructions: string;
  DeliveryInstructions: string;
}
type ThunkArgs = { updatedPayload: Loads; loadsId: any };

type initialStateProps = {
  isLoading: boolean;
  type: 'loads' | 'save-loads' | 'loads-mapping' | 'active-loads';
  data: Loads[] | [] | any;
  error: string | null;
  count: null;
};
const initialState: initialStateProps = {
  isLoading: false,
  type: 'loads',
  data: [],
  error: null,
  count: null
};

interface activeList {
  isLoading: boolean;
  activeList: any;
  error: null;
}
const activeNames: activeList = {
  isLoading: false,
  activeList: null,
  error: null
};

interface freightList {
  isLoading: boolean;
  freightList: any;
  error: null;
}
const freight: freightList = {
  isLoading: false,
  freightList: null,
  error: null
};

interface deactivateData {
  isLoading: boolean;
  deactivates: any;
  error: null;
}
const deactivate: deactivateData = {
  isLoading: false,
  deactivates: null,
  error: null
};

interface deleteData {
  isLoading: boolean;
  deleteLoads: any;
  error: null;
}
const deleteLoad: deleteData = {
  isLoading: false,
  deleteLoads: null,
  error: null
};

interface addAllLoads {
  isLoading: boolean;
  loaddata: any;
  error: null;
}
const addload: addAllLoads = {
  isLoading: false,
  loaddata: null,
  error: null
};

interface updateAllLoads {
  isLoading: boolean;
  updatedata: any;
  error: null;
}
const updateload: updateAllLoads = {
  isLoading: false,
  updatedata: null,
  error: null
};

const pagination = {
  pageNo: 1,
  pageSize: 5
};

// get loads
export const getLoads = createAsyncThunk<ReturnedType, any>(
  'api/load',
  async (data, thunkApi) => {
    try {
      const {
        pageNo = 1,
        pageSize = 5,
        sortColumnName,
        sortBy,
        searchInput,
        searchColumnName,
        signal
      } = data;

      let url = `${URLs.GET_LOADS}?pageNo=${pageNo}&pageSize=${pageSize}`;

      if (sortBy && sortColumnName && searchColumnName && searchInput) {
        url += `&sortBy=${sortBy}&sortColumnName=${sortColumnName}&searchInput=${searchInput}&searchColumnName=${searchColumnName}`;
      } else if (sortBy && sortColumnName && searchInput) {
        url += `&sortBy=${sortBy}&sortColumnName=${sortColumnName}&searchInput=${searchInput}`;
      } else if (searchInput && searchColumnName) {
        url += `&searchInput=${searchInput}&searchColumnName=${searchColumnName}`;
      } else if (sortBy && sortColumnName && searchInput && searchColumnName) {
        url += `&sortBy=${sortBy}&sortColumnName=${sortColumnName}&searchInput=${searchInput}&searchColumnName=${searchColumnName}`;
      } else if (sortBy && sortColumnName && searchInput) {
        url += `&sortBy=${sortBy}&sortColumnName=${sortColumnName}&searchInput=${searchInput}`;
      } else if (searchInput) {
        url += `&searchInput=${searchInput}`;
      } else if (sortBy && sortColumnName) {
        url += `&sortBy=${sortBy}&sortColumnName=${sortColumnName}`;
      }
      const response = await axiosInstance({
        method: 'GET',
        url: url,
        signal: signal
      });
      return response?.data;
    } catch (error: any) {
      if (error?.message !== 'canceled') {
        thunkApi.dispatch(
          updateToast({
            show: true,
            message: error?.response?.data?.message
              ? error?.response?.data?.message
              : error?.message,
            severity: 'error'
          })
        );
      }
      return thunkApi.rejectWithValue(error);
    }
  }
);

const loads = createSlice({
  name: 'loads',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getLoads.pending, state => {
        state.isLoading = true;
        state.data = [];
      })
      .addCase(getLoads.fulfilled, (state, action: any) => {
        state.isLoading = false;
        const {
          data: { loadDetails, loadDetailsListCount }
        } = action.payload;
        state.data = loadDetails?.map((value: any) => ({
          ...value,
          id: value.id,
          loadType: value?.loadType,
          loadNumber: value?.loadNumber,
          truckLoadType: value?.truckLoadType,
          loadName: value?.loadName,
          weight: value?.weight,
          length: value?.length,
          width: value?.width,
          height: value?.height,
          customerAddress: value?.customerAddress,
          customerLatitude: value?.customerLatitude,
          customerLongitude: value?.customerLongitude,
          totalCost: value?.totalCost,
          description: value?.description,
          customerId: value?.customerId,
          isActive: value?.isActive,
          freightNames:
            value?.freightNumbers && value?.freightNumbers.length > 0
              ? value?.freightNumbers
              : 'NA',
          stackholder: value?.stakeholderPairModels,
          latitude: value?.customerLatitude,
          longitude: value?.customerLongitude,
          company: value?.customerId,
          type: 'Logistics'
        }));
        state.count = loadDetailsListCount;
        state.error = null;
      })
      .addCase(getLoads.rejected, (state, action: any) => {
        state.isLoading = false;
        state.data = [];
        state.error = action.payload?.response?.data.error || 'Something went wrong';
      });
  }
});

// get active names
export const getActiveNames = createAsyncThunk<any, any>(
  'api/active/names',
  async (signal, thunkApi) => {
    try {
      const response = await axiosInstance({
        method: 'GET',
        url: `${URLs.LOADS_ACTIVE_USERS}`,
        signal: signal
      });
      return response?.data?.data;
    } catch (error: any) {
      if (error?.message !== 'canceled') return thunkApi.rejectWithValue(error);
    }
  }
);

export const activeName = createSlice({
  name: 'activeNames',
  initialState: activeNames,
  reducers: {},
  extraReducers: builder => {
    builder

      .addCase(getActiveNames.pending, state => {
        state.isLoading = true;
        state.activeList = [];
      })
      .addCase(getActiveNames.fulfilled, (state, action: PayloadAction<activeList[]>) => {
        state.isLoading = false;
        state.activeList = action?.payload;
        state.error = null;
      })
      .addCase(getActiveNames.rejected, (state, action: any) => {
        state.isLoading = false;
        state.activeList = [];
        state.error = action.payload?.response?.data.error || 'Something went wrong';
      });
  }
});

// get freight names
export const freightNames = createAsyncThunk<any, any>(
  'freight/names',
  async (data, thunkApi) => {
    try {
      const response = await axiosInstance({
        method: 'GET',
        url: `${URLs.FREIGHT_NAMES}`,
        signal: data
      });
      return response?.data?.data;
    } catch (error: any) {
      if (error?.message !== 'canceled') return thunkApi.rejectWithValue(error);
    }
  }
);

export const freightActiveName = createSlice({
  name: 'freight names',
  initialState: freight,
  reducers: {},
  extraReducers: builder => {
    builder

      .addCase(freightNames.pending, state => {
        state.isLoading = true;
        state.freightList = [];
      })
      .addCase(freightNames.fulfilled, (state, action: PayloadAction<freightList[]>) => {
        state.isLoading = false;
        state.freightList = action?.payload;
        state.error = null;
      })
      .addCase(freightNames.rejected, (state, action: any) => {
        state.isLoading = false;
        state.freightList = [];
        state.error = action.payload?.response?.data.error || 'Something went wrong';
      });
  }
});

// delete loads
export const deleteLoads = createAsyncThunk<ReturnedType, any>(
  'delete/loads',
  async (data, thunkApi) => {
    try {
      const response = await axiosInstance({
        method: 'DELETE',
        url: `${URLs.DELETE_LOADS}?id=${data}`
      });
      thunkApi.dispatch(
        updateToast({
          show: true,
          message: response?.data?.message,
          severity: 'success'
        })
      );
      return response?.data?.data;
    } catch (error: any) {
      thunkApi.dispatch(
        updateToast({
          show: true,
          message: error?.response?.data?.error
            ? error?.response?.data?.error
            : error?.response?.data?.message,
          severity: 'error'
        })
      );
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const deleteLoadSlice = createSlice({
  name: 'delete loads',
  initialState: deleteLoad,
  reducers: {},
  extraReducers: builder => {
    builder

      .addCase(deleteLoads.pending, state => {
        state.isLoading = true;
        state.deleteLoads = [];
      })
      .addCase(deleteLoads.fulfilled, (state, action: PayloadAction<deleteData[]>) => {
        state.isLoading = false;
        state.deleteLoads = action?.payload;
        state.error = null;
      })
      .addCase(deleteLoads.rejected, (state, action: any) => {
        state.isLoading = false;
        state.deleteLoads = [];
        state.error = action.payload?.response?.data.error || 'Something went wrong';
      });
  }
});

// deactivate loads
export const deactiveLoads = createAsyncThunk<ReturnedType, any>(
  'api/deactivate',
  async (data, thunkApi) => {
    try {
      const response = await axiosInstance({
        method: 'PATCH',
        url: `${URLs.DEACTIVATE_LOADS}?id=${data}`
      });
      thunkApi.dispatch(
        updateToast({
          show: true,
          message: response?.data?.message,
          severity: 'success'
        })
      );
      return response?.data?.data;
    } catch (error: any) {
      thunkApi.dispatch(
        updateToast({
          show: true,
          message: error.response.data?.error,
          severity: 'error'
        })
      );
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const deactivateLoadNames = createSlice({
  name: 'deactivate loads',
  initialState: deactivate,
  reducers: {},
  extraReducers: builder => {
    builder

      .addCase(deactiveLoads.pending, state => {
        state.isLoading = true;
        state.deactivates = [];
      })
      .addCase(
        deactiveLoads.fulfilled,
        (state, action: PayloadAction<deactivateData[]>) => {
          state.isLoading = false;
          state.deactivates = action?.payload;
          state.error = null;
        }
      )
      .addCase(deactiveLoads.rejected, (state, action: any) => {
        state.isLoading = false;
        state.deactivates = [];
        state.error = action.payload?.response?.data.error || 'Something went wrong';
      });
  }
});

// add loads
export const addLoads = createAsyncThunk<ReturnedType, any>(
  'api/add',
  async (data, thunkApi) => {
    try {
      const response = await axiosInstance({
        method: 'POST',
        url: `${URLs.ADD_LOADS}`,
        data
      });
      await thunkApi.dispatch(getLoads(pagination));

      thunkApi.dispatch(
        updateToast({
          show: true,
          message: response?.data?.message,
          severity: 'success'
        })
      );
      return response.data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const addLoadnames = createSlice({
  name: 'add loads',
  initialState: addload,
  reducers: {},
  extraReducers: builder =>
    builder

      .addCase(addLoads.pending, state => {
        state.isLoading = true;
      })
      .addCase(addLoads.fulfilled, (state, action: any) => {
        state.loaddata = action?.payload?.data;
        state.isLoading = false;
        state.error = null;
      })
      .addCase(addLoads.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.error.message || 'Something went wrong';
      })
});

// update loads
export const updateLoads = createAsyncThunk<ReturnedType, any>(
  'api/update',
  async (data, thunkApi) => {
    try {
      const response = await axiosInstance({
        method: 'PUT',
        url: `${URLs.UPDATE_LOADS}?id=${data.id}`,
        data: data.updatePayload
      });
      thunkApi.dispatch(
        updateToast({
          show: true,
          message: 'Load details updated successfully',
          severity: 'success'
        })
      );
      await thunkApi.dispatch(getLoads(pagination));
      return response?.data?.data;
    } catch (error: any) {
      thunkApi.dispatch(
        updateToast({
          show: true,
          message: error.response.data?.error,
          severity: 'error'
        })
      );
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const updateAllLoads = createSlice({
  name: 'update loads',
  initialState: updateload,
  reducers: {},
  extraReducers: builder =>
    builder
      .addCase(updateLoads.pending, state => {
        state.isLoading = true;
      })
      .addCase(updateLoads.fulfilled, (state, action: PayloadAction<updateAllLoads>) => {
        state.isLoading = false;
        state.updatedata = action?.payload?.updatedata;
        state.error = null;
      })
      .addCase(updateLoads.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action?.payload?.response?.data?.error || 'Something went wrong';
      })
});

export const updateAllLoad = updateAllLoads.reducer;
export const loadsallLoad = addLoadnames.reducer;
export const deactivateNameLoads = deactivateLoadNames.reducer;
export const loadsActiveFreights = freightActiveName.reducer;
export const loadsActiveNames = activeName.reducer;
export const loadAll = loads.reducer;
export const deleteAllLoad = deleteLoadSlice.reducer;
